import React, { useState } from 'react';

const OrderDeliveryMobile = ({ delivery }) => {
  const [opened, setOpened] = useState(true);

  const fullAddress = [
    delivery.street,
    delivery.buildingNumber,
    delivery.flatNumber ? `кв. ${delivery.flatNumber}` : null,
  ]
    .filter(Boolean)
    .join(', ');

  if (!delivery) return null;

  const {
    name,
    surname,
    phone,
    deliveryDescription,
    city,
    departmentNumber,
    street,
    buildingNumber,
    flatNumber,
  } = delivery;

  const isDepartment = Boolean(departmentNumber);

  return (
    <div className='card mb-3'>
      <div
        className='card-header p-2 d-flex justify-content-between align-items-center cursor-pointer'
        onClick={() => setOpened(prev => !prev)}
      >
        <h5 className='card-title font-weight-bold m-0'>
          🚚 Доставка
        </h5>
        <span className='text-muted font-weight-bold'>
            {opened ? '−' : '+'}
          </span>
      </div>

      {/* ===== CARD BODY ===== */}
      {opened && (
        <div className='card-body'>
          <p className='card-text mb-2'>
            <strong>Тип доставки:</strong> {deliveryDescription}
          </p>

          <p className='card-text mb-1'>
            <strong>Імʼя:</strong> {name}
          </p>

          <p className='card-text mb-1'>
            <strong>Прізвище:</strong> {surname}
          </p>

          <p className='card-text mb-2'>
            <strong>Телефон:</strong> {phone}
          </p>

          {isDepartment && (
            <>
              <p className='card-text mb-1'>
                <strong>Місто:</strong> {city}
              </p>
              <p className='card-text mb-0'>
                <strong>Номер відділення / поштомату:</strong> {departmentNumber}
              </p>
            </>
          )}

          {!isDepartment && street && (
            <>
              <p className='card-text mb-1'>
                <strong>Місто:</strong> {city}
              </p>
              <p className='card-text mb-0'>
                <strong>Адреса:</strong> {fullAddress}
              </p>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default OrderDeliveryMobile;
